<template>

	<button type="button" class="edit_booking_button button solid small" v-on:click="toggleEditBooking()"><i class="fal fa-edit"></i><span>Edit</span></button>

</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'uuid'
	],

	data: () => {
		return {
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
	},

	methods: {

		toggleEditBooking: function(){
			this.$root.$refs.editbooking.toggleEditBooking(this.uuid);
		}

	}
};
</script>